import { WalletConnect } from "./components/WalletConnect";
import axios from "axios";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
axios.defaults.baseURL = "https://store.cloud9.gg";
// axios.defaults.baseURL = "https://c9testingground.myshopify.com";
Sentry.init({
    dsn: "https://d22f865fc29c4c609b1e04ebcb7381d9@o1383688.ingest.sentry.io/6775749",
    enabled: true,
    debug: true,
    environment: "development",
    release: "react.shopify.app@1.0.0",
    attachStacktrace: true,
    autoSessionTracking: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});
var walletElement = document.getElementById("app-root");
walletElement && ReactDOM.render(React.createElement(WalletConnect, null), walletElement);
